import { notEmpty, type Optional } from '@festina-life/core'

import { getOptional } from '../formikForms/formikUtils/formikUtils'
import { useFormikContext } from './useFormikContext'

export const useFormikIsRequired = (
  name: string,
  isRequired: Optional<boolean>,
): boolean => {
  const { status } = useFormikContext()
  const isOptional = getOptional(status.yupFields, name)

  return notEmpty(isRequired) ? isRequired : !isOptional
}
